import { useState } from 'react';
import { Button } from 'reactstrap';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

import { getCountry } from '@front-activerse/common-components';
import { withMobileAppMode } from '@front-activerse/common-components';
import { callNativeMobileApp } from '@front-activerse/common-components';

const FriscoButton = ({ meal, publicName, mobileApp }) => {
  const {
    consts: {
      FRISCO_FIREBASE_FUNCTION,
      FRISCO_PARTNER,
      FRISCO_DESKROP_URL_PL,
      FRISCO_DESKROP_URL_EN,
      APP_BRAND,
    },
    images: { friscoLogo, friscoLogoBanner, friscoBannerImg },
  } = useAppContext();

  const { t, language } = useTranslator();

  const [preloadFrisco, setPreloadFrisco] = useState(false);

  const handleFrisco = async () => {
    const ingredients = [];

    meal.dishes.forEach((dish) => {
      dish.ingredients.forEach((ingredient) => {
        const measurement = ingredient.measurements[ingredient.measurements.length - 1];
        const measure = `${measurement.amount}${measurement.text.replace('%s', '')}`;

        ingredients.push(`${measure} ${ingredient.name}`);
      });
    });

    const request = {
      name: publicName,
      ingredients,
    };

    setPreloadFrisco(true);

    const response = await fetch(FRISCO_FIREBASE_FUNCTION, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    response.json().then((data) => {
      setPreloadFrisco(false);

      if (data.friscoUrl) {
        console.log('data.friscoUrl', data.friscoUrl);
        const friscoURL = encodeURIComponent(data.friscoUrl);
        const partner = encodeURIComponent(FRISCO_PARTNER);
        const friscoDeepLink = `https://frisco.pl/go-to-app?partner=friscoach_affiliate_${partner}&jsonUrl=${friscoURL}`;

        if (mobileApp && mobileApp.os && mobileApp.os.toLowerCase().startsWith('ios')) {
          callNativeMobileApp({
            action: 'deeplink_open',
            payload: {
              url: friscoDeepLink,
            },
          });
        } else {
          window.location = friscoDeepLink;
        }
      }
    });
  };

  const urlMap = {
    'en-US': FRISCO_DESKROP_URL_EN,
    'pl-PL': FRISCO_DESKROP_URL_PL,
  };

  if (getCountry() === 'Poland') {
    return (
      <div className="text-center">
        <Button
          color="frisco"
          className="d-md-none w-100 py-3"
          onClick={handleFrisco}
          disabled={preloadFrisco}
        >
          {t('orderIngredients.frisco.button')}{' '}
          <img
            src={friscoLogo}
            style={{
              verticalAlign: 'baseline',
              height: '16px',
            }}
            alt="instacart"
          />
        </Button>
        <a
          href={urlMap[language]}
          className="d-none d-md-inline-block btn btn-frisco w-100 py-3"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('orderIngredients.frisco.button')}{' '}
          <img
            src={friscoLogo}
            style={{
              verticalAlign: 'baseline',
              height: '16px',
            }}
            alt="instacart"
          />
        </a>

        {APP_BRAND === 'oxy' && (
          <>
            <button
              className="frisco-banner d-flex d-md-none align-items-center justify-content-between"
              onClick={handleFrisco}
              disabled={preloadFrisco}
            >
              <div>
                <img src={friscoLogoBanner} alt="frisco" className="mb-1" />
                <h4>
                  <span>35 zł</span> rabatu na zakupy we Frisco
                </h4>
                <p>
                  Przy zakupach za min 250 zł
                  <br />
                  Oferta jednorazowa i obowiązuje do 30.01.2026
                </p>
              </div>
              <img src={friscoBannerImg} className="frisco-banner-img" alt="frisco banner" />
            </button>

            <a
              href={urlMap[language]}
              className="frisco-banner d-none d-md-flex align-items-center justify-content-between"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>
                <img src={friscoLogoBanner} alt="frisco" className="mb-1" />
                <h4>
                  <span>35 zł</span> rabatu na zakupy we Frisco
                </h4>
                <p>
                  Przy zakupach za min 250 zł
                  <br />
                  Oferta jednorazowa i obowiązuje do 30.01.2026
                </p>
              </div>
              <img src={friscoBannerImg} className="frisco-banner-img" alt="frisco banner" />
            </a>
          </>
        )}
      </div>
    );
  }

  return null;
};

export default withMobileAppMode(FriscoButton);
